export const parseUser = _ref => {
  let {
    analytics_id,
    company,
    email,
    first_name,
    id,
    last_name,
    name,
    nickname,
    uid,
    image_url,
    job_title,
    phone
  } = _ref;
  return {
    analyticsId: analytics_id,
    company,
    email,
    firstName: first_name,
    id,
    lastName: last_name,
    name,
    nickname,
    oxygenId: uid,
    imageUrl: image_url,
    jobTitle: job_title,
    phone
  };
};
//# sourceMappingURL=parseUser.js.map